export function formattingString(str: string): string {
  return str.replace(/\s+/g, ' ').trim();
}
